/* eslint-disable react-hooks/exhaustive-deps */
import { Box, withStyles } from '@material-ui/core';
import { TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/types';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import classNames from 'classnames';

import { hideToast, setPageTitle, showToast } from 'modules/layout/layout.actions';
import { getAuthClientPoliciesList } from 'modules/authorizations/store/actions/authorizations.actions';
import {
  getAllCountries,
  getAllCurrencies,
  getAllEnumerations,
  getAllProvinces,
  getAllSaleTypes,
  getAllWeightTypes
} from 'modules/enumerations/store/enumerationActions';
import { fetchEnumerations  } from 'modules/authorizations/utils/fetchDataDetailsService';
import { createTheme, ThemeProvider } from '@mui/material';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import { GET_VENDORS_FAILURE } from 'modules/authorizations/types';
import { getVendors } from 'modules/authorizations/authorizations.actions';
import { GET_FEE_BY_ID_FAILURE } from 'modules/fees/fees.types';
import FullscreenSpinner from 'modules/common/fullscreenSpinner.component';
import FeeDetails from './feeDetails.component';
import { getFeeById, setFeeId } from 'modules/fees/fees.actions.js';
import { Permissions } from 'modules/layout/permissions';
import { hasPermission } from 'modules/layout/permissionService';

const styles = theme => ({
  box: {
    height: '100%'
  },
  form: {
    backgroundColor: theme.palette.common.white,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  navContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexDirection: 'row',
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(2)
  },
  tabsRoot: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2)
  },
  tab: {
    width: 120,
    minWidth: 120
  }
});

function FeeDetailsView(props) {
  const [reloadData, setReloadData] = useState(true);
  const { location, setPageTitle: propsSetPageTitle, feeDetails, enumerations, isLoading } = props;

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  //initial load of form
  useEffect(() => {
    propsSetPageTitle('Fee Details');

    setReloadData(true);
  }, [location]);

  //reload data
  useEffect(() => {
    if (reloadData) {
      setReloadData(false);
      loadData();
    }
    async function loadData() {
      props.hideToast();

      const id = props.match.params.feeRecordId;

      props.setFeeId(id);

      if (!props.vendors) {
        let { type } = await props.getVendors();
        if (type === GET_VENDORS_FAILURE) {
          props.showToast('Failed to retrieve vendors, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
        }
      }

      await fetchEnumerations(props);

      // // Fetch full client info
      // if (!props.feeDetails) {
        const resp = await props.getFeeById(id);
        if (resp.type === GET_FEE_BY_ID_FAILURE) {
          props.showToast('Failed to retrieve data, please try again', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
          return;
        }

      

    }
  }, [reloadData]);

  const canReadFees = hasPermission(Permissions.Finance.Fees.Read);

  if (!canReadFees) {
    props.history.push('/');
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <Box pl={1} pr={1} classes={{ root: classNames(props.classes.box) }}>
        {(isLoading || !feeDetails) && <FullscreenSpinner />}
        {!isLoading && feeDetails && enumerations && (
            <FeeDetails feeDetails={feeDetails} enumerations={enumerations} isReadOnly={canReadFees} />
        )}
      </Box>
    </ThemeProvider>
  );
}

FeeDetailsView.propTypes = {
  classes: PropTypes.object.isRequired,
  feeDetails: PropTypes.object.isRequired,
  setPageTitle: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  location: ReactRouterPropTypes.location.isRequired,
  match: ReactRouterPropTypes.match.isRequired,
  isLoading: PropTypes.bool.isRequired,
  showToast: PropTypes.func.isRequired,
  hideToast: PropTypes.func.isRequired,
  theme: PropTypes.object,
};

const mapStateToProps = state => {
  const { clientPolicies } = state.authorizations;
  const { authorizationDetails } = state.authorizations;
  const { feeDetails, feeRecordId } = state.fees;
  const enumerations = state.enumerations;
  const { vendors } = state.authorizations;

  return {
    feeDetails,
    feeRecordId,
    clientPolicies,
    enumerations,
    vendors,
    authorizationDetails
  };
};

export default compose(
  withStyles(styles),
  withRouter,
  withTheme,
  connect(mapStateToProps, {
    setPageTitle,
    hideToast,
    showToast,
    getAuthClientPoliciesList,
    getAllEnumerations,
    getAllSaleTypes,
    getAllWeightTypes,
    getAllProvinces,
    getAllCurrencies,
    getAllCountries,
    getVendors,
    getFeeById,
    setFeeId
  })
)(FeeDetailsView);